module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "ipadfp"
  }, [_c('img', {
    staticClass: "imagefp",
    attrs: {
      "alt": "Cover: The Hard Seltzer Cocktail Book, by Casie Vogel",
      "aria-describedby": "cover-alt",
      "epub:type": "cover",
      "role": "doc-cover",
      "src": "e9781646042197/images/9781646042197.jpg"
    }
  })]), _vm._v(" "), _c('aside', {
    attrs: {
      "hidden": "hidden",
      "id": "cover-alt"
    }
  }, [_c('p', [_vm._v("The Hard Seltzer Cocktail Book")]), _vm._v(" "), _c('p', [_vm._v("55 Unofficial Recipes for White ClawⓇ Slushies, TrulyⓇ Mixers, and More\n            Spiked-Seltzer Drinks")]), _vm._v(" "), _c('p', [_vm._v("Casie Vogel")]), _vm._v(" "), _c('p', [_vm._v("Independently Authored and Published")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-752ee18b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781646042197/xhtml/cover.vue
// module id = 54
// module chunks = 0